import React from "react";

type Props = {
  label: string;
  value: string | React.ReactNode;
};

const BoxAndLabel: React.FC<Props> = ({ label, value }) => (
  <div className={"gap-1 flex flex-col items-center w-full"}>
    <p className={"font-normal text-[--secondary]"}>{label}</p>
    <div
      className={
        "bg-[#eee] font rounded-md font-semibold text-[--secondary] flex flex-row items-center justify-center w-full h-[42px]"
      }
    >
      {value}
    </div>
  </div>
);

export default BoxAndLabel;
